module.exports = __webpack_public_path__ + "static/media/derickson-loss.c47cc6bb.png";